// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "__federation_expose_app" + "." + "37626faf3cfd6eb6" + ".css"
}